import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconFacebookLogoFilled = generateIcon({
  name: 'FacebookLogoFilled',
  path: (
    <>
      <g clipPath="url(#clip0_3814_707)">
        <path d="M16 3C23.1797 3 29 8.85586 29 16.0794C29 22.6079 24.2461 28.0188 18.0312 29V28.8421V19.8602H21.0604L21.6367 16.0794H21.6245L21.6367 16H18.0312V13.626C18.0312 12.5917 18.535 11.5834 20.1498 11.5834H21.7891V11.5312V8.36462V8.33203C21.7891 8.33203 20.3014 8.07812 18.879 8.07812C15.9096 8.07812 13.9688 9.87781 13.9688 13.1359V13.1979V16H10.668V16.0794V19.7578V19.8602H13.9688V28.8421V29C7.75389 28.0188 3 22.6077 3 16.0794C3 8.85586 8.82029 3 16 3Z" />
      </g>
      <defs>
        <clipPath id="clip0_3814_707">
          <rect width="26" height="26" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </>
  ),
});
